module.exports = __webpack_public_path__ + "img/cam_2_off.38be0160.png";